import {
  byCityAndAliasUrlMatcher,
  bySalonIdUrlMatcher,
} from '@app/shared/url-matchers/url-matchers';
import { BookingPartSmartComponent, BookingCompletedComponent, PaymentPendingComponent } from '@app/booking-part';
import {
  VisitDetailsResolverService, SalonPageResolverService
} from '@app/shared/guards';
import {
  GiftsListResolverService
} from '@app/gifts';
import { Routes } from "@angular/router";
import {
  SalonDetailsStandaloneContextComponent
} from "@app/salon-details/salon-details/context/standalone/salon-details-standalone-context.component";
import {
  SalonDetailsBjootifyContextComponent
} from "@app/salon-details/salon-details/context/bjootify/salon-details-bjootify-context.component";

export const salonDetailsModuleRoutes: Routes = [{
  path: 'salon',
  children: [
    {
      matcher: bySalonIdUrlMatcher,
      children: [
        {
          path: '',
          data: { bodyCssClass: 'bjootify-salon-page' },
          component: SalonDetailsStandaloneContextComponent,
          resolve: {
            salonPage: SalonPageResolverService
          }
        },
        {
          path: 'booking',
          data: { bodyCssClass: 'bjootify-booking' },
          component: BookingPartSmartComponent
        },
        {
          path: ':visitId',
          children: [
            {
              path: '',
              pathMatch: 'full',
              redirectTo: '/'
            },
            {
              path: 'payment-pending',
              data: { bodyCssClass: 'bjootify-payment-pending' },
              component: PaymentPendingComponent,
              resolve: {
                visitDetails: VisitDetailsResolverService
              }
            },
            {
              path: 'booking-completed',
              data: { bodyCssClass: 'bjootify-booking-completed' },
              component: BookingCompletedComponent,
              resolve: {
                visitDetails: VisitDetailsResolverService,
                gifts: GiftsListResolverService
              }
            }
          ]
        },
      ]
    },
    {
      matcher: byCityAndAliasUrlMatcher,
      children: [
        {
          path: '',
          data: { bodyCssClass: 'bjootify-salon-page' },
          component: SalonDetailsBjootifyContextComponent,
          resolve: {
            salonPage: SalonPageResolverService
          }
        },
        {
          path: 'booking',
          data: { bodyCssClass: 'bjootify-booking' },
          component: BookingPartSmartComponent
        },
        {
          path: ':visitId',
          children: [
            {
              path: '',
              pathMatch: 'full',
              redirectTo: '/'
            },
            {
              path: 'payment-pending',
              data: { bodyCssClass: 'bjootify-payment-pending' },
              component: PaymentPendingComponent,
              resolve: {
                visitDetails: VisitDetailsResolverService
              }
            },
            {
              path: 'booking-completed',
              data: { bodyCssClass: 'bjootify-booking-completed' },
              component: BookingCompletedComponent,
              resolve: {
                visitDetails: VisitDetailsResolverService,
                gifts: GiftsListResolverService
              }
            }
          ]
        },
      ]
    },

  ]
}];
